import React from "react";
import FigmaIcon from "./icons/FigmaIcon";
import ProposalIcon from "./icons/ProposalIcon";

export function AgentActionIcon({ size = 20, color = "currentColor" }) {
  return <FigmaIcon name="agent" size={size} color={color} />;
}

export function JobActionIcon({ size = 20, color = "currentColor" }) {
  return <FigmaIcon name="job" size={size} color={color} />;
}

export function AddActionIcon({ size = 20, color = "currentColor" }) {
  return <FigmaIcon name="add" size={size} color={color} />;
}

export function MoveStageActionIcon({ size = 20, color = "currentColor" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      style={{ display: "block", flexShrink: 0 }}
    >
      <path
        d="M12 5L12 19"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 17L12 20L15 17"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 7L12 4L9 7"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 12L19 12"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 15L20 12L17 9"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 9L4 12L7 15"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SequenceActionIcon({ size = 20, color = "currentColor" }) {
  return <FigmaIcon name="sequence" size={size} color={color} />;
}

export function LeadActionIcon({ size = 20, color = "currentColor" }) {
  return <FigmaIcon name="contact" size={size} color={color} />;
}

export function NoteActionIcon({ size = 20, color = "currentColor" }) {
  return <FigmaIcon name="document" size={size} color={color} />;
}

export function MatchActionIcon({ size = 20, color = "currentColor" }) {
  return <FigmaIcon name="match" size={size} color={color} />;
}

export function ProposalActionIcon({ size = 18 }) {
  return <ProposalIcon size={size} />;
}

export function getDefaultActionButtonStartIcon(label, size = 18) {
  const normalizedLabel = String(label || "").trim().toLowerCase();

  if (!normalizedLabel) {
    return null;
  }

  if (normalizedLabel === "move stage" || normalizedLabel.includes("move stage")) {
    return <MoveStageActionIcon size={size} />;
  }

  if (normalizedLabel === "add") {
    return <AddActionIcon size={size} />;
  }

  if (
    normalizedLabel === "add agent" ||
    normalizedLabel === "launch agent" ||
    normalizedLabel === "ai agent" ||
    normalizedLabel.includes("agent")
  ) {
    return <AgentActionIcon size={size} />;
  }

  if (
    normalizedLabel === "add to job" ||
    normalizedLabel === "add job" ||
    normalizedLabel === "add new job" ||
    normalizedLabel === "new job"
  ) {
    return <JobActionIcon size={size} />;
  }

  if (normalizedLabel === "contact lead" || normalizedLabel === "lead") {
    return <LeadActionIcon size={size} />;
  }

  if (
    normalizedLabel === "add note" ||
    normalizedLabel === "add notes" ||
    normalizedLabel === "note"
  ) {
    return <NoteActionIcon size={size} />;
  }

  if (normalizedLabel === "sequence" || normalizedLabel.includes("sequence")) {
    return <SequenceActionIcon size={size} />;
  }

  if (normalizedLabel.includes("proposal")) {
    return <ProposalActionIcon size={size} />;
  }

  if (normalizedLabel.includes("match")) {
    return <MatchActionIcon size={size} />;
  }

  return null;
}
